import z from 'zod';
import { successOpenApiDescription } from '../../constants/schemas.constants';
import { configSchema } from './config.schema';

export const configResponseSchemaRef = 'configResponse';

export const configResponseSchema = z
	.object({
		success: z.boolean().meta(successOpenApiDescription),
		config: configSchema,
	})
	.meta({
		description: 'Schema for config response.',
		ref: configResponseSchemaRef,
	})
	.strict();

export type ConfigResponseSchemaType = z.infer<typeof configResponseSchema>;
